var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCabinet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 4H2V36H38V4ZM36 6H4V10H36V6ZM18 13H32V14H18V13ZM32 19H18V20H32V19ZM6 27H34V28H6V27ZM34 16H18V17H34V16ZM6 30H34V31H6V30ZM14.3328 15.3842C14.3328 15.4546 14.3305 15.5253 14.326 15.5961C15.0674 15.1964 15.9995 14.9612 15.9995 14.9612C15.9995 14.9612 15.5134 15.5253 15.1662 16.5831C14.8649 17.5009 13.518 18.1532 13.1668 18.3098C12.8985 18.6329 12.6012 18.9132 12.2943 19.1304C12.3199 19.546 12.3549 20.0043 12.401 20.3928C12.9213 20.6109 13.4662 20.787 13.9575 20.9243C14.9614 21.2049 15.7848 21.9803 16 23.0002H6C6.21522 21.9803 7.03856 21.2049 8.04244 20.9243C8.53134 20.7876 9.07321 20.6125 9.59107 20.3959C9.63752 20.0056 9.67367 19.5444 9.70051 19.1267C9.39538 18.9101 9.09979 18.6311 8.83284 18.3098C8.48164 18.1532 7.13475 17.5009 6.83348 16.5831C6.48625 15.5253 6.00014 14.9612 6.00014 14.9612C6.00014 14.9612 6.93164 15.1962 7.67292 15.5958C7.66844 15.5251 7.66615 15.4545 7.66615 15.3842C7.66615 13.3687 9.3335 11.9993 11.0008 12C12.6681 12.0007 14.3328 13.3687 14.3328 15.3842Z",
    fill: "#9A9CAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinet);
export default __webpack_public_path__ + "static/media/cabinet.b235864d.svg";
export { ForwardRef as ReactComponent };